import { FormControlLabel } from '@mui/material'
import { styled } from '@mui/material/styles'
import { COLORS } from 'utils'

export const BpIcon = styled('span')(() => ({
  '.Mui-focusVisible &': {
    outline: `2.5px solid ${COLORS.lightGray}`,
    outlineOffset: 2
  },
  backgroundColor: '#FEFEFE',
  backgroundImage:
    'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  // borderRadius: 3,
  // boxShadow:
  //   "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",

  height: 17,
  'input:disabled ~ &': {
    background: '#C7C9C7',
    borderRadius: 2,
    boxShadow: 'none'
  },
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5'
  },
  outline: `2.5px solid #C7C9C7`,
  width: 17
}))

export const BpCheckedIcon = styled(BpIcon)({
  '&:before': {
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
    display: 'block',
    height: 20,
    width: 20
  },
  backgroundColor: COLORS.blueFonts,
  backgroundImage:
    'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  'input:hover ~ &': {
    backgroundColor: `${COLORS.blueFonts}99`
  },
  outline: `2.5px solid ${COLORS.blueFonts}`
})

export interface IFormControlLabelStyled {
  marginTop?: string
  marginRight?: string
  marginBottom?: string
  marginLeft?: string
}
export const FormControlLabelStyled = styled(
  FormControlLabel
)<IFormControlLabelStyled>`
  .MuiFormControlLabel-label {
    color: ${COLORS.black};
  }

  margin-top: ${({ marginTop }) => marginTop || 0};
  margin-left: ${({ marginLeft }) => marginLeft || 0};
  margin-right: ${({ marginRight }) => marginRight || 0};
  margin-bottom: ${({ marginTop }) => marginTop || 0};
`
